// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bqydopqekazcedqvpxzo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJxeWRvcHFla2F6Y2VkcXZweHpvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ0NTg5MDgsImV4cCI6MjA0MDAzNDkwOH0.EXhHWzGBUIG5i4mW_WDsj1PbOAC7qG_fmb41KRGpDPc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);